export default function getDayName(
  date = new Date(),
  format = "short",
  locale = "en-US",
) {
  return date?.toLocaleDateString(locale, { weekday: format });
}

export function getMonthName(date = new Date(), format = "short", locale = "en-US") {
  return date?.toLocaleDateString(locale, { month: format });
}

export function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

export const reqexpForDate = /(-|\+)\d{2}:\d{2}/g;

export const getTime = (date) => {
  const currentDate = new Date(date?.replace(reqexpForDate, ""));

  return `${padTo2Digits(currentDate?.getHours())}:${padTo2Digits(
    currentDate?.getMinutes(),
  )}`;
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  
  if (isNaN(date.getTime())) {
    return dateString;
  }

  const options = {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };

  return date.toLocaleDateString("en-US", options);
}
